import {
  DexfSettingsEnvironmentEnum,
  DexfSettingsFilterSegmentEnum,
} from "@inter-ikea-kompis/enums"
import {SettingsService} from "@inter-ikea-kompis/services"
import {IDexfSettings} from "@inter-ikea-kompis/types"

export default class DexfSettings {
  public getSettings(): Promise<IDexfSettings> {
    const settingsService = new SettingsService({
      dexfApiKey: "ed299ee2-a032-4b71-8e9d-75c74144d1d6",
      dexfEnvironment: DexfSettingsEnvironmentEnum.production, // defaults to the production environment in DEXF if not provided. Note that the dexfApiKey must be the one linked to the correct environment
      dexfApplicationId: "dekis", // name of the application, e.g. pax, platsa and so on
      locale: "en-SE",
    })
    const filterSegment = DexfSettingsFilterSegmentEnum.production
    return settingsService.getApplicationSettings(filterSegment)
  }
}
